// Replacement for https://lodash.com/docs/4.17.15#identity
export const identity = (value: unknown): boolean => Boolean(value);
